var NavigationRouterTypeEnum = /* @__PURE__ */ ((NavigationRouterTypeEnum2) => {
  NavigationRouterTypeEnum2["Memory"] = "memory";
  NavigationRouterTypeEnum2["Browser"] = "browser";
  NavigationRouterTypeEnum2["Hash"] = "hash";
  return NavigationRouterTypeEnum2;
})(NavigationRouterTypeEnum || {});
var HistoryLocationActionEnum = /* @__PURE__ */ ((HistoryLocationActionEnum2) => {
  HistoryLocationActionEnum2["ResetFilters"] = "reset-filters";
  HistoryLocationActionEnum2["SetFilters"] = "set-filters";
  HistoryLocationActionEnum2["SetSort"] = "set-sort";
  HistoryLocationActionEnum2["SetOffset"] = "set-offset";
  return HistoryLocationActionEnum2;
})(HistoryLocationActionEnum || {});
var QueryParamsEnum = /* @__PURE__ */ ((QueryParamsEnum2) => {
  QueryParamsEnum2["ScrollTo"] = "scroll-to";
  return QueryParamsEnum2;
})(QueryParamsEnum || {});
export {
  HistoryLocationActionEnum,
  NavigationRouterTypeEnum,
  QueryParamsEnum
};
